module.exports = __webpack_public_path__ + "img/HU22567671.bb89462c.png";